(function ($) {
  'use strict';

  // Size the product loads with. The DPO options otherwise default to 5x5,
  // which looks tiny in the preview; a larger, common frame size reads better.
  // These are whole inches (change here to adjust the loaded default).
  var DEFAULT_ORDER_HEIGHT = 14;
  var DEFAULT_ORDER_WIDTH = 11;
  var DEFAULT_PREVIEW_HEIGHT = DEFAULT_ORDER_HEIGHT;
  var DEFAULT_PREVIEW_WIDTH = DEFAULT_ORDER_WIDTH;
  var framePreviewInitialized = false;
  var previewSizeDefaulted = false;

  var DIMENSION_PAIRS = [
    {
      group: 'height',
      mainLabels: ['Height', 'Length', 'Outside Height Dimension'],
      fracLabels: ['Height Fraction', 'Length Fraction', 'Outside Height Fraction'],
      defaultHeading: 'Height',
      icon: '↕'
    },
    {
      group: 'width',
      mainLabels: ['Width', 'Outside Width Dimension'],
      fracLabels: ['Width Fraction', 'Outside Width Fraction'],
      defaultHeading: 'Width',
      icon: '↔'
    }
  ];

  function findFieldByLabels($root, labels) {
    var $found = null;

    $root.find('.form-list .field').each(function () {
      if ($(this).closest('.ff-dimension-group').length) {
        return;
      }

      var label = $(this).find('label').first().text().trim();
      if (labels.indexOf(label) !== -1) {
        $found = $(this);
        return false;
      }
    });

    return $found;
  }

  var UNICODE_FRACTIONS = {
    '½': '1/2',
    '¼': '1/4',
    '¾': '3/4',
    '⅛': '1/8',
    '⅜': '3/8',
    '⅝': '5/8',
    '⅞': '7/8',
    '⅓': '1/3',
    '⅔': '2/3'
  };

  function normalizeFractionText(text) {
    if (!text) {
      return text;
    }

    var trimmed = text.trim();
    return UNICODE_FRACTIONS[trimmed] || trimmed;
  }

  function isDashPlaceholder(value) {
    if (!value) {
      return true;
    }

    var v = value.trim();
    return v === '--' || v === '---' || v === '—' || /^-+$/.test(v);
  }

  function isEmptyFraction(fraction) {
    if (!fraction) {
      return true;
    }

    var f = fraction.trim().toLowerCase();

    if (isDashPlaceholder(f)) {
      return true;
    }

    return f === '0' || f === 'none' || f === 'n/a';
  }

  function isValidWholeInches(whole) {
    if (!whole || isDashPlaceholder(whole)) {
      return false;
    }

    return /^\d+(\.\d+)?$/.test(whole.trim());
  }

  function getFieldValue($field) {
    var $select = $field.find('select').first();

    if ($select.length) {
      // DPO stores internal option IDs in value (e.g. 10001); display text is the real size.
      var text = $select.find('option:selected').text().trim();

      if (isDashPlaceholder(text)) {
        return '';
      }

      return text;
    }

    var $input = $field.find('input').first();
    var inputVal = $input.length ? ($input.val() || '').trim() : '';

    return isDashPlaceholder(inputVal) ? '' : inputVal;
  }

  function formatInches(whole, fraction) {
    whole = (whole || '').trim();

    if (!isValidWholeInches(whole)) {
      return null;
    }

    if (isEmptyFraction(fraction)) {
      return whole + '"';
    }

    var frac = normalizeFractionText(fraction).replace(/^-/, '');
    return whole + '-' + frac + '"';
  }

  function parseFractionDecimal(fraction) {
    if (isEmptyFraction(fraction)) {
      return 0;
    }

    var frac = normalizeFractionText(fraction).replace(/^-/, '');
    var parts = frac.split('/');

    if (parts.length === 2) {
      var numerator = parseFloat(parts[0]);
      var denominator = parseFloat(parts[1]);

      if (denominator) {
        return numerator / denominator;
      }
    }

    var asNumber = parseFloat(frac);
    return isNaN(asNumber) ? 0 : asNumber;
  }

  function parseInchesDecimal(whole, fraction) {
    whole = (whole || '').trim();

    if (!isValidWholeInches(whole)) {
      return null;
    }

    return parseFloat(whole) + parseFractionDecimal(fraction);
  }

  function getDimensionInchesFromGroup($group) {
    if (!$group || !$group.length) {
      return null;
    }

    var whole = getFieldValue($group.find('.ff-dimension-group__field--whole'));
    var frac = getFieldValue($group.find('.ff-dimension-group__field--fraction'));

    return parseInchesDecimal(whole, frac);
  }

  function getDimensionInchesFromLabels($root, pair) {
    var $main = findFieldByLabels($root, pair.mainLabels);
    var $frac = findFieldByLabels($root, pair.fracLabels);

    if (!$main || !$frac) {
      return null;
    }

    return parseInchesDecimal(getFieldValue($main), getFieldValue($frac));
  }

  function readCurrentDimensions() {
    var $root = $('#itoris_dynamicproductoptions');
    var heightIn = getDimensionInchesFromGroup($root.find('.ff-dimension-group--height'));
    var widthIn = getDimensionInchesFromGroup($root.find('.ff-dimension-group--width'));

    if (!heightIn) {
      heightIn = getDimensionInchesFromLabels($root, DIMENSION_PAIRS[0]);
    }

    if (!widthIn) {
      widthIn = getDimensionInchesFromLabels($root, DIMENSION_PAIRS[1]);
    }

    return {
      heightIn: heightIn,
      widthIn: widthIn,
      fromDpo: !!(heightIn && widthIn)
    };
  }

  // Map a floater "spacing" option label to inches. "No Spacing" -> 0,
  // "1/4\" Spacing" -> 0.25, "1/2\" Spacing" -> 0.5. Returns null if it can't
  // be parsed.
  function textToSpacingInches(text) {
    if (!text) {
      return null;
    }

    var t = text.toLowerCase();
    var frac = t.match(/(\d+)\s*\/\s*(\d+)/);

    if (frac) {
      var den = parseFloat(frac[2]);
      return den ? parseFloat(frac[1]) / den : null;
    }

    var dec = t.match(/(\d+(?:\.\d+)?)\s*(?:in|inch|")/);

    if (dec) {
      return parseFloat(dec[1]);
    }

    if (t.indexOf('no') !== -1 && !/\d/.test(t)) {
      return 0;
    }

    return null;
  }

  // Read the storefront's floater "spacing between artwork and floater frame"
  // selection (radio, checkbox, or select). Returns inches or null when there's
  // no such option (e.g. non-floater products).
  function readFloaterSpacingInches() {
    var $root = $('#itoris_dynamicproductoptions');

    if (!$root.length) {
      return null;
    }

    var result = null;

    $root.find('.field').each(function () {
      if (result !== null) {
        return;
      }

      var $field = $(this);

      if ($field.text().toLowerCase().indexOf('spacing') === -1) {
        return;
      }

      var text = '';
      var $checked = $field.find('input[type="radio"]:checked, input[type="checkbox"]:checked');

      if ($checked.length) {
        var id = $checked.attr('id');

        if (id) {
          var $lbl = $root.find('label[for="' + id + '"]');
          if ($lbl.length) {
            text = $lbl.text();
          }
        }

        if (!text) {
          text = $checked.closest('label').text();
        }

        if (!text) {
          text = $checked.parent().text();
        }
      } else {
        var $sel = $field.find('select').first();
        if ($sel.length) {
          text = $sel.find('option:selected').text();
        }
      }

      var inches = textToSpacingInches(text);

      if (inches !== null) {
        result = inches;
      }
    });

    return result;
  }

  function isFloaterProduct() {
    var el = document.getElementById('ff-frame-preview');
    return !!(el && el.getAttribute('data-is-floater') === 'true');
  }

  var floaterSpacingDefaulted = false;

  // The visualizer defaults to a 1/4" float gap, but the DPO spacing options
  // start with nothing selected — confusing. On floater products, pre-select
  // the 1/4" spacing option once so the storefront and preview agree.
  function ensureDefaultFloaterSpacing() {
    if (floaterSpacingDefaulted || !isFloaterProduct()) {
      return;
    }

    var $root = $('#itoris_dynamicproductoptions');
    if (!$root.length) {
      return;
    }

    $root.find('.field').each(function () {
      if (floaterSpacingDefaulted) {
        return;
      }

      var $field = $(this);
      if ($field.text().toLowerCase().indexOf('spacing') === -1) {
        return;
      }

      var $inputs = $field.find('input[type="radio"], input[type="checkbox"]');
      if (!$inputs.length) {
        // A <select> already has a default option selected; nothing to force.
        floaterSpacingDefaulted = true;
        return;
      }

      if ($inputs.filter(':checked').length) {
        // Customer (or the app) already chose one — leave it alone.
        floaterSpacingDefaulted = true;
        return;
      }

      var target = null;
      $inputs.each(function () {
        var input = this;
        var text = '';
        if (input.id) {
          var $lbl = $root.find('label[for="' + input.id + '"]');
          if ($lbl.length) {
            text = $lbl.text();
          }
        }
        if (!text) {
          text = $(input).closest('label').text() || $(input).parent().text();
        }
        if (textToSpacingInches(text) === 0.25) {
          target = input;
          return false;
        }
      });

      if (target) {
        target.checked = true;
        // DPO listens for native change events to recalc price/options.
        if ('createEvent' in document) {
          var evt = document.createEvent('HTMLEvents');
          evt.initEvent('change', false, true);
          target.dispatchEvent(evt);
        } else if (target.fireEvent) {
          target.fireEvent('onchange');
        }
        $(target).trigger('change');
        floaterSpacingDefaulted = true;
      }
    });
  }

  function syncFloaterGap() {
    if (!window.FFFrameRenderer || !window.FFFrameRenderer.setFloaterGap) {
      return;
    }

    ensureDefaultFloaterSpacing();

    var gap = readFloaterSpacingInches();

    if (gap !== null) {
      window.FFFrameRenderer.setFloaterGap(gap);
    }
  }

  function updateFramePreview() {
    if (!window.FFFrameRenderer || !document.getElementById('ff-frame-preview')) {
      return;
    }

    syncFloaterGap();

    var dims = hasArtworkInputs() ? readArtworkDimensions() : readCurrentDimensions();
    var heightIn = dims.heightIn || DEFAULT_PREVIEW_HEIGHT;
    var widthIn = dims.widthIn || DEFAULT_PREVIEW_WIDTH;

    window.FFFrameRenderer.update(heightIn, widthIn);

    // Let the kit add-ons prototype recompute area-based prices off the same
    // dimensions the preview is drawing.
    if (typeof document.dispatchEvent === 'function') {
      document.dispatchEvent(
        new CustomEvent('ff:dimensions-changed', {
          detail: { heightIn: dims.heightIn, widthIn: dims.widthIn }
        })
      );
    }
  }

  function initFramePreview() {
    if (!document.getElementById('ff-frame-preview') || !window.FFFrameRenderer) {
      return;
    }

    if (!framePreviewInitialized) {
      window.FFFrameRenderer.init('#ff-frame-preview');
      framePreviewInitialized = true;
    }

    updateFramePreview();
  }

  function dimensionDescriptor(heading) {
    var h = (heading || '').trim().toLowerCase();

    if (h === 'length') {
      return 'long';
    }
    if (h.indexOf('height') !== -1) {
      return 'tall';
    }
    if (h.indexOf('width') !== -1) {
      return 'wide';
    }

    return h;
  }

  function placeDimensionSummary($summary) {
    // Prefer placing the summary immediately after the DPO options container so
    // it reads right below the size fields the customer just filled in (and so
    // the kit panel, which anchors to this summary, follows the size entry near
    // the top of the page rather than sitting above it in the price block).
    var $dpo = $('#itoris_dynamicproductoptions');

    if ($dpo.length) {
      $dpo.after($summary);
      return;
    }

    var $mount = $('#ff-dimension-summary-mount');

    if ($mount.length) {
      $mount.after($summary);
      return;
    }

    var $price = $('.product-detail .product-form .price-container').first();

    if ($price.length) {
      $price.after($summary);
      return;
    }

    var $groups = $('#itoris_dynamicproductoptions .ff-dimension-group');

    if ($groups.length) {
      $groups.last().after($summary);
    }
  }

  function ensureDimensionSummary() {
    var $root = $('#itoris_dynamicproductoptions');

    if (!$root.find('.ff-dimension-group').length) {
      return null;
    }

    var $summary = $('.product-detail .ff-dimension-summary');

    if (!$summary.length) {
      $summary = $('<div class="ff-dimension-summary" aria-live="polite"></div>');
    }

    placeDimensionSummary($summary);
    return $summary;
  }

  function updateDimensionSummary() {
    var $root = $('#itoris_dynamicproductoptions');
    var groupPrefix = hasArtworkInputs() ? '.ff-art-group--' : '.ff-dimension-group--';
    var $heightGroup = $root.find(groupPrefix + 'height');
    var $widthGroup = $root.find(groupPrefix + 'width');
    var $summary = ensureDimensionSummary();

    if (!$summary) {
      updateFramePreview();
      return;
    }

    var parts = [];

    if ($heightGroup.length) {
      var heightWhole = getFieldValue($heightGroup.find('.ff-dimension-group__field--whole'));
      var heightFrac = getFieldValue($heightGroup.find('.ff-dimension-group__field--fraction'));
      var heightFormatted = formatInches(heightWhole, heightFrac);
      var heightHeading = $heightGroup.find('.ff-dimension-group__label').text().trim();

      if (heightFormatted) {
        parts.push({
          size: heightFormatted,
          word: dimensionDescriptor(heightHeading)
        });
      }
    }

    if ($widthGroup.length) {
      var widthWhole = getFieldValue($widthGroup.find('.ff-dimension-group__field--whole'));
      var widthFrac = getFieldValue($widthGroup.find('.ff-dimension-group__field--fraction'));
      var widthFormatted = formatInches(widthWhole, widthFrac);
      var widthHeading = $widthGroup.find('.ff-dimension-group__label').text().trim();

      if (widthFormatted) {
        parts.push({
          size: widthFormatted,
          word: dimensionDescriptor(widthHeading)
        });
      }
    }

    if (!parts.length) {
      $summary.hide().empty();
      updateFramePreview();
      return;
    }

    // Keep the renderer's float gap in sync with the storefront's spacing
    // option before we read floater/mat context for the note below.
    syncFloaterGap();

    var hasRenderer = window.FFFrameRenderer && document.getElementById('ff-frame-preview');
    var heightIn = parseInchesDecimal(heightWhole, heightFrac);
    var widthIn = parseInchesDecimal(widthWhole, widthFrac);

    // Floater frames: the entered size is the canvas; the frame opening =
    // canvas + the selected float gap on each side.
    var floaterCtx =
      hasRenderer && heightIn && widthIn && window.FFFrameRenderer.getFloaterContextFor
        ? window.FFFrameRenderer.getFloaterContextFor(heightIn, widthIn)
        : null;

    // When a matboard is applied, the entered size is the frame's opening / the
    // mat's outer size — not the artwork. Ask the renderer for the current mat
    // context so the note can say so and quote the resulting visible window.
    var matCtx =
      hasRenderer && heightIn && widthIn && window.FFFrameRenderer.getMatContextFor
        ? window.FFFrameRenderer.getMatContextFor(heightIn, widthIn)
        : null;

    var frameSizeDisplay;
    var detailPhrase;
    var titlePrefix = 'Frame Size: ';

    if (parts.length === 2) {
      frameSizeDisplay =
        '<span class="ff-dimension-summary__measure">' +
        parts[1].size +
        ' x ' +
        parts[0].size +
        '</span>';

      if (floaterCtx) {
        if (floaterCtx.noSpacing) {
          detailPhrase =
            'This floater frame\u2019s opening is made to your exact ' +
            parts[1].size +
            ' \u00d7 ' +
            parts[0].size +
            ' canvas (no float gap). Canvas sizes vary \u2014 most floaters use at least a 1/4" gap, so double\u2011check your measurements before choosing no spacing.';
        } else {
          detailPhrase =
            'This floater frame is built for a ' +
            parts[1].size +
            ' \u00d7 ' +
            parts[0].size +
            ' canvas. With the ' +
            floaterCtx.gapLabel +
            ' float gap on each side, the frame opening is made ' +
            floaterCtx.openingWidthLabel +
            ' \u00d7 ' +
            floaterCtx.openingHeightLabel +
            '.';
        }
      } else if (matCtx) {
        var openingLabel =
          (matCtx.openingWidthLabel || parts[1].size) +
          ' \u00d7 ' +
          (matCtx.openingHeightLabel || parts[0].size);

        if (matCtx.basis === 'artwork') {
          titlePrefix = 'Artwork size: ';
          var matLead =
            'Your artwork stays ' +
            matCtx.artFitWidthLabel +
            ' \u00d7 ' +
            matCtx.artFitHeightLabel +
            '. The ' +
            matCtx.borderLabel +
            ' ' +
            matCtx.colorName.toLowerCase() +
            ' mat sits around it, so your frame and the outside of your mat are ' +
            openingLabel +
            '. ';
        } else {
          var matLead =
            'Adding the ' +
            matCtx.borderLabel +
            ' ' +
            matCtx.colorName.toLowerCase() +
            ' mat enlarged the frame opening to ' +
            parts[1].size +
            ' \u00d7 ' +
            parts[0].size +
            ' to fit your ' +
            matCtx.artFitWidthLabel +
            ' \u00d7 ' +
            matCtx.artFitHeightLabel +
            ' artwork. ';
        }

        var matTail =
          ' Finished (outside) size is about ' +
          matCtx.finishedWidthLabel +
          ' \u00d7 ' +
          matCtx.finishedHeightLabel +
          '.';

        if (matCtx.hasOverlap) {
          detailPhrase =
            matLead +
            'The mat laps ' +
            matCtx.overlapLabel +
            ' over each edge, so about ' +
            matCtx.windowWidthLabel +
            ' \u00d7 ' +
            matCtx.windowHeightLabel +
            ' of your art shows.' +
            matTail;
        } else {
          detailPhrase =
            matLead +
            'With no overlap the window is ' +
            matCtx.windowWidthLabel +
            ' \u00d7 ' +
            matCtx.windowHeightLabel +
            ' \u2014 turn on overlap so the art can\u2019t slip through.' +
            matTail;
        }
      } else {
        detailPhrase =
          'Your frame\u2019s opening will be made ' +
          parts[1].size +
          ' \u00d7 ' +
          parts[0].size +
          ' to fit your artwork \u2014 that\u2019s the opening on the back your art sits inside.';
      }
    } else {
      frameSizeDisplay =
        '<span class="ff-dimension-summary__measure">' + parts[0].size + '</span>';
      detailPhrase =
        'Your frame\u2019s opening will be made ' +
        parts[0].size +
        ' to fit your artwork \u2014 that\u2019s the opening on the back your art sits inside.';
    }

    $summary
      .html(
        '<div class="ff-dimension-summary__title">' +
          titlePrefix +
          frameSizeDisplay +
          '</div>' +
          '<div class="ff-dimension-summary__note">' +
          detailPhrase +
          '</div>'
      )
      .show();

    updateFramePreview();
  }

  function bindDimensionSummaryListeners() {
    var $root = $('#itoris_dynamicproductoptions');

    $root
      .find('.ff-dimension-group select, .ff-dimension-group input')
      .off('change.ffDimensionSummary input.ffDimensionSummary')
      .on('change.ffDimensionSummary input.ffDimensionSummary', updateDimensionSummary);

    updateDimensionSummary();
  }

  function tightenDimensionGroups() {
    var $root = $('#itoris_dynamicproductoptions');
    if (!$root.length) {
      return false;
    }

    var grouped = false;

    DIMENSION_PAIRS.forEach(function (pair) {
      if ($root.find('.ff-dimension-group--' + pair.group).length) {
        return;
      }

      var $main = findFieldByLabels($root, pair.mainLabels);
      var $frac = findFieldByLabels($root, pair.fracLabels);

      if (!$main || !$frac) {
        return;
      }

      var mainLabelText = $main.find('label').first().text().trim();
      var heading = pair.defaultHeading;
      if (mainLabelText === 'Length') {
        heading = 'Length';
      } else if (mainLabelText.indexOf('Outside Height') !== -1) {
        heading = 'Outside height';
      } else if (mainLabelText.indexOf('Outside Width') !== -1) {
        heading = 'Outside width';
      }

      var $group = $('<div class="ff-dimension-group ff-dimension-group--' + pair.group + '"></div>');
      // Group label on its own line (like the mockup's .field > label), then a
      // tidy grid row of [whole select] & [fraction select] inches beneath it.
      var $head = $('<div class="ff-dimension-group__head"></div>');
      var $row = $('<div class="ff-dimension-group__row"></div>');
      var $icon = $('<span class="ff-dimension-group__icon" aria-hidden="true"></span>').text(pair.icon);
      var $label = $('<span class="ff-dimension-group__label"></span>').text(heading);
      var $and = $('<span class="ff-dimension-group__and" aria-hidden="true">&</span>');
      var $unit = $('<span class="ff-dimension-group__unit">inches</span>');

      $main.find('label').first().text('Whole inches').addClass('ff-dimension-group__field-label');
      $frac.find('label').first().text('Fraction').addClass('ff-dimension-group__field-label');
      $main.addClass('ff-dimension-group__field--whole');
      $frac.addClass('ff-dimension-group__field--fraction');

      $frac.find('select option').each(function () {
        var $option = $(this);
        var normalized = normalizeFractionText($option.text());
        if (normalized !== $option.text().trim()) {
          $option.text(normalized);
        }
      });

      $main.before($group);
      // Label on its own head line; the direction arrow sits inline next to the
      // inputs (leading column of the fields row), aligned with the selects.
      $head.append($label);
      $row
        .append($icon)
        .append($main)
        .append($and)
        .append($frac)
        .append($unit);
      $group.append($head).append($row);

      grouped = true;
    });

    // Sizes read width x height everywhere, so the width inputs come first.
    var hGroup = $root.find('.ff-dimension-group--height').get(0);
    var wGroup = $root.find('.ff-dimension-group--width').get(0);
    if (hGroup && wGroup && (hGroup.compareDocumentPosition(wGroup) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      hGroup.parentNode.insertBefore(wGroup, hGroup);
    }

    return grouped;
  }

  function bindDpoRootListeners() {
    var $root = $('#itoris_dynamicproductoptions');

    if (!$root.length) {
      return;
    }

    $root
      .find('select, input')
      .off('change.ffDimensionRoot input.ffDimensionRoot')
      .on('change.ffDimensionRoot input.ffDimensionRoot', function () {
        tightenDimensionGroups();
        ensureArtworkInputs();
        // The frame size is derived from the artwork; if DPO resets it on its
        // own, put it back once DPO finishes its pass.
        if (hasArtworkInputs() && $(this).closest('.ff-dimension-group').not('.ff-art-group').length) {
          setTimeout(syncFrameFromArtwork, 0);
        }
        updateDimensionSummary();
      });
  }

  function waitForDpoFields(attempt) {
    attempt = attempt || 0;

    var grouped = tightenDimensionGroups();
    var hasGroups = $('#itoris_dynamicproductoptions .ff-dimension-group').length > 0;
    var dims = readCurrentDimensions();

    if (hasGroups) {
      ensureDefaultPreviewSize();
      ensureArtworkInputs();
      bindDimensionSummaryListeners();
      bindDpoRootListeners();
      updateFramePreview();
      return;
    }

    if (dims.fromDpo) {
      bindDpoRootListeners();
      updateDimensionSummary();
      updateFramePreview();
      return;
    }

    if (attempt > 150) {
      bindDpoRootListeners();
      updateFramePreview();
      return;
    }

    if (attempt === 0 || attempt % 5 === 0) {
      updateFramePreview();
    }

    setTimeout(function () {
      waitForDpoFields(attempt + 1);
    }, 200);
  }

  function setSelectByText($select, text) {
    if (!$select || !$select.length) {
      return false;
    }

    var el = $select[0];
    var matched = false;

    $select.find('option').each(function () {
      var optionText = normalizeFractionText($(this).text());

      if (optionText === text) {
        el.value = this.value;
        matched = true;
        return false;
      }
    });

    if (matched) {
      // DPO attaches native change listeners to recalc price, so dispatch a
      // real DOM change event (not just jQuery's).
      if ('createEvent' in document) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        el.dispatchEvent(evt);
      } else if (el.fireEvent) {
        el.fireEvent('onchange');
      }

      $select.trigger('change');
    }

    return matched;
  }

  function findDimensionSelects(pair, groupClass) {
    var $root = $('#itoris_dynamicproductoptions');
    var $whole = $root.find('.ff-dimension-group--' + groupClass + ' .ff-dimension-group__field--whole select');
    var $frac = $root.find('.ff-dimension-group--' + groupClass + ' .ff-dimension-group__field--fraction select');

    if (!$whole.length) {
      var $main = findFieldByLabels($root, pair.mainLabels);
      $whole = $main ? $main.find('select') : $();
    }

    if (!$frac.length) {
      var $fracField = findFieldByLabels($root, pair.fracLabels);
      $frac = $fracField ? $fracField.find('select') : $();
    }

    return { whole: $whole, frac: $frac };
  }

  function setDimensions(heightWhole, heightFrac, widthWhole, widthFrac) {
    if (hasArtworkInputs()) {
      setArtworkSelects('height', heightWhole, heightFrac);
      setArtworkSelects('width', widthWhole, widthFrac);
      syncFrameFromArtwork();
      updateDimensionSummary();
      return true;
    }
    var height = findDimensionSelects(DIMENSION_PAIRS[0], 'height');
    var width = findDimensionSelects(DIMENSION_PAIRS[1], 'width');

    var ok = false;

    if (setSelectByText(height.whole, String(heightWhole))) {
      ok = true;
    }
    setSelectByText(height.frac, heightFrac || '---');

    if (setSelectByText(width.whole, String(widthWhole))) {
      ok = true;
    }
    setSelectByText(width.frac, widthFrac || '---');

    updateDimensionSummary();
    updateFramePreview();

    return ok;
  }

  // On first load, swap the DPO's 5x5 default for a larger, more representative
  // size so the preview isn't a tiny square. Runs once, before the customer
  // interacts; if they change a size we never override it afterward.
  function ensureDefaultPreviewSize() {
    if (previewSizeDefaulted) {
      return;
    }
    var height = findDimensionSelects(DIMENSION_PAIRS[0], 'height');
    var width = findDimensionSelects(DIMENSION_PAIRS[1], 'width');
    if (!height.whole.length || !width.whole.length) {
      return; // fields not ready yet
    }
    previewSizeDefaulted = true;
    setSelectByText(height.whole, String(DEFAULT_ORDER_HEIGHT));
    setSelectByText(width.whole, String(DEFAULT_ORDER_WIDTH));
  }

  // ---- Kit page: the artwork size drives the frame size ---------------------
  // With the kit panel on the page, the customer enters the ARTWORK size in a
  // copy of the size inputs. The real DPO size fields, which DPO prices and the
  // order carries, hold the frame opening: artwork + 2 x mat border, or the
  // artwork alone without a mat. The mat's outside matches the frame opening.
  // The preview and the size note work from the artwork size.
  var FRACTION_TEXT = ['---', '1/8', '1/4', '3/8', '1/2', '5/8', '3/4', '7/8'];

  function artMode() {
    return !!document.getElementById('ff-kit-addons');
  }

  function hasArtworkInputs() {
    return artMode() && $('#itoris_dynamicproductoptions .ff-art-group').length > 0;
  }

  function readArtworkDimensions() {
    var $root = $('#itoris_dynamicproductoptions');
    var heightIn = getDimensionInchesFromGroup($root.find('.ff-art-group--height'));
    var widthIn = getDimensionInchesFromGroup($root.find('.ff-art-group--width'));
    return { heightIn: heightIn, widthIn: widthIn, fromDpo: !!(heightIn && widthIn) };
  }

  function matBorderIn() {
    var cb = document.getElementById('ff-frame-mat-enabled');
    var sel = document.getElementById('ff-frame-mat-border');
    if (!cb || !cb.checked || !sel) {
      return 0;
    }
    var b = parseFloat(sel.value);
    return b > 0 ? b : 0;
  }

  function toWholeFrac(inches) {
    var eighths = Math.round(inches * 8);
    return { whole: String(Math.floor(eighths / 8)), frac: FRACTION_TEXT[eighths % 8] };
  }

  function selectTextQuietly(select, text) {
    for (var i = 0; i < select.options.length; i += 1) {
      if (normalizeFractionText(select.options[i].textContent) === text) {
        select.selectedIndex = i;
        return true;
      }
    }
    return false;
  }

  function setArtworkSelects(group, whole, frac) {
    var $g = $('#itoris_dynamicproductoptions .ff-art-group--' + group);
    var w = $g.find('.ff-dimension-group__field--whole select').get(0);
    var f = $g.find('.ff-dimension-group__field--fraction select').get(0);
    if (w) {
      selectTextQuietly(w, String(whole));
    }
    if (f) {
      selectTextQuietly(f, frac || '---');
    }
  }

  // Push artwork + border into the real DPO size fields. Selects are looked up
  // fresh for each write so a DPO re-render between writes cannot strand one side.
  function syncFrameFromArtwork() {
    if (!hasArtworkInputs()) {
      return;
    }
    var art = readArtworkDimensions();
    if (!art.heightIn || !art.widthIn) {
      return;
    }
    var b = matBorderIn();
    var want = { height: toWholeFrac(art.heightIn + b * 2), width: toWholeFrac(art.widthIn + b * 2) };
    ['height', 'width'].forEach(function (group, i) {
      var pair = DIMENSION_PAIRS[i];
      var sel = findDimensionSelects(pair, group);
      var curWhole = normalizeFractionText(sel.whole.find('option:selected').text());
      if (curWhole !== want[group].whole) {
        setSelectByText(sel.whole, want[group].whole);
      }
      sel = findDimensionSelects(pair, group);
      var curFrac = normalizeFractionText(sel.frac.find('option:selected').text()) || '---';
      if (curFrac !== want[group].frac) {
        setSelectByText(sel.frac, want[group].frac);
      }
    });
  }

  function ensureArtworkInputs() {
    if (!artMode()) {
      return;
    }
    var $root = $('#itoris_dynamicproductoptions');
    if ($root.find('.ff-art-group').length) {
      return;
    }
    var $realW = $root.find('.ff-dimension-group--width').first();
    var $realH = $root.find('.ff-dimension-group--height').first();
    if (!$realW.length || !$realH.length) {
      return;
    }

    // Off-screen rather than display:none: DPO resets fields it cannot see.
    if (!document.getElementById('ff-art-size-style')) {
      $('<style id="ff-art-size-style">' +
        '#itoris_dynamicproductoptions .ff-dimension-group--width,' +
        '#itoris_dynamicproductoptions .ff-dimension-group--height{' +
        'position:absolute !important;left:-10000px !important;top:0 !important;' +
        'width:1px !important;height:1px !important;overflow:hidden !important;' +
        'clip-path:inset(50%) !important}' +
        '</style>').appendTo('head');
    }

    var start = {
      height: {
        whole: getFieldValue($realH.find('.ff-dimension-group__field--whole')),
        frac: getFieldValue($realH.find('.ff-dimension-group__field--fraction'))
      },
      width: {
        whole: getFieldValue($realW.find('.ff-dimension-group__field--whole')),
        frac: getFieldValue($realW.find('.ff-dimension-group__field--fraction'))
      }
    };

    function artworkCopy($real, group) {
      var $copy = $real.clone(false);
      $copy.removeClass('ff-dimension-group--' + group).addClass('ff-art-group ff-art-group--' + group);
      $copy.find('[id]').removeAttr('id');
      $copy.find('[name]').removeAttr('name');
      $copy.find('.product-custom-option').removeClass('product-custom-option');
      $copy.find('input').remove();
      return $copy;
    }
    var $wCopy = artworkCopy($realW, 'width');
    var $hCopy = artworkCopy($realH, 'height');
    $realW.before($wCopy);
    $wCopy.after($hCopy);

    setArtworkSelects('width', start.width.whole, start.width.frac);
    setArtworkSelects('height', start.height.whole, start.height.frac);

    $root.find('.ff-art-group select').on('change.ffArtwork', function () {
      syncFrameFromArtwork();
      updateDimensionSummary();
    });

    syncFrameFromArtwork();
    updateDimensionSummary();
  }

  $(document).on('change.ffArtwork', '#ff-frame-mat-enabled, #ff-frame-mat-border', function () {
    syncFrameFromArtwork();
    updateDimensionSummary();
  });

  window.FFDpoDimensions = {
    setDimensions: setDimensions,
    refresh: updateDimensionSummary,
    getDimensions: readCurrentDimensions,
    getArtwork: function () {
      return hasArtworkInputs() ? readArtworkDimensions() : readCurrentDimensions();
    }
  };

  function init() {
    initFramePreview();
    waitForDpoFields(0);
  }

  $(document).ready(init);

  var prevBeforeInit = window.dpo_before_initialize;
  window.dpo_before_initialize = function () {
    if (prevBeforeInit) {
      prevBeforeInit.apply(this, arguments);
    }
    setTimeout(init, 50);
  };

  var prevAfterInit = window.dpo_after_initialize;
  window.dpo_after_initialize = function () {
    if (prevAfterInit) {
      prevAfterInit.apply(this, arguments);
    }
    setTimeout(init, 50);
  };
})(jQuery);
